import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { gettoken } from "../Localstorage/Store";
import axios from "axios";
import {  useSelector } from "react-redux";


const Thankyoupage = () => {
  const { bgColor, textColor } = useSelector((state) => state.theam);

  const [loading,setloading] = useState(true)
  const [msg,setmsg] = useState('')
  const location = useLocation();
  const nvg = useNavigate();
console.log("location of laoction",location)
  useEffect(()=>{
if(location.state.orderinfo){
if(location.state?.msg == "save to cart"){
  setmsg(location.state.msg)
}
  setloading(false)
}
  },[location])


    return(
  <>
<div>
<Header />

<section className=" pt-5 mt-5">
          <div className="col-lg-12 col-sm-12  mt-lg-5 mt-xs-4 mb-2">
            {/* <div className='container-fluid bigdiv'> */}
            <div className="container-fluid">
              <div className="row Thankpage">
                <div className="col-lg-12 col-sm-12 col-md-12">
                <div className="TextTankyou">
               <div className="Imgverify"> <img src="./images/newlogo/thankyou.png" alt="img-fluid" style={{width:'23%'}} className="boyimg"/></div>
                    <h2 className="Fontthank" style={{fontWeight:'600'}}>{location?.state?.msg == "save to cart" ? <>Your Cart Has Been Saved</> : <><span style={{color:`#${bgColor}`}}>Thank you</span> for your order</>}  <img src="./images/icon/Group2.png" alt="404" className="Checkimg2"/></h2>
                </div>
                <div>
                    <p className="text-center" style={{color:'#8F9091'}} > 
                      
                      {location?.state?.msg == "save to cart" ? 
                      <>Your Cart no <span onClick={()=>{nvg(`/saved-cart-pay/${location?.state?.orderid}`)}} style={{color:`#${bgColor}`,textDecoration:'underline',cursor:'pointer'}}>{location?.state?.orderid}</span> and Waiting For Admin Approval </> 
                    : <>
                      Your order no{' '}
                      <span
                        onClick={() => nvg(`/order-history-detail/${location?.state?.orderid}`)}
                        style={{
                          color: `#${bgColor}`,
                          textDecoration: 'underline',
                          cursor: 'pointer',
                        }}
                      >
                        {location?.state?.orderid}
                      </span>{' '}
                      has been placed and is being processed. You will receive an email with order details.
                    </>
                    }  
                        
                    </p>
                </div>
                <div className="backTohome" style={{paddingTop:'10px' ,display: 'flex', justifyContent: 'center', alignItems: 'center',color : `#${bgColor}`}}>
                <NavLink to="/home" style={{lineHeight:'20px',  color: `#${bgColor} !important`,fontSize:'14px' }} >Back To Home Page</NavLink> 
                </div>
               


                </div>

                
              </div>
            </div>
          </div>
        </section>

  {/* footer start */}
  <Footer />
  {/* footer end */}

 
</div>




        </>
    )
}
export default Thankyoupage;